import { Guid } from '@/models/identify';

export enum SocialTabType{
    blocks,
    dialogs
}

export abstract class SocialTab {
    protected _id: string;
    protected _name?: string;
    protected _params?: object;
    protected _url?: string;
    protected _selected: boolean = false;

    public constructor(name?: string, params?: object, contentUrl?: string) {
        this._id = Guid.generation();
        this._name = name;
        this._params = params;
        this._url = contentUrl;
    }

    public get id(): string { return this._id; }

    public get name(): string|undefined { return this._name; }

    public get contentUrl(): string|undefined { return this._url; }

    //Selected
    public set selected(value: boolean) { 
        this._selected = value; 
        if(this._selected && !this.hasContent()){
            this.nextPage();
        }
    }

    public get selected(): boolean { return this._selected; }

    public get contentType(): string|undefined { 
        return this._params?.type ? this._params?.type : undefined; 
    }

    abstract get type(): SocialTabType;

    //Abstract 
    abstract hasContent(): boolean;
    abstract hasNextPage(): boolean;
    abstract nextPage(): void;
    abstract getData(): Array<object>;
}